import { render, staticRenderFns } from "./CreateAutoActivityForm.vue?vue&type=template&id=b1f42006&lang=pug&"
import script from "./CreateAutoActivityForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateAutoActivityForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports